<template>
  <div>
    <vs-popup
      title="Stok Detayı"
      button-cancel="border"
      @cancel="clearFields"
      @close="clearFields"
      :active.sync="isSidebarActiveLocal"
      classContent="popup-example"
      fullscreen
    >
      <KategoriOzellik
        :popupActiveSiparis2Popup="popupActiveSiparis2"
        :marketplace="activeMarketplace"
        :categoryId="stockDetailCategoryId"
        :stockData="data"
      />
      <vs-card>
        <b-row align-h="center">
          <b-col cols="12" md="auto" v-if="stockName != ''">
            <h5 class="text-danger">Stok Kart Bilgisi</h5>
          </b-col>
          <b-col cols="12" md="auto">
            <h5 class="text-dark">{{ stockName }}</h5>
          </b-col>
          <b-col cols="12" md="auto" v-if="stockCode != ''">
            <h5 class="text-danger">Stok Kodu</h5>
          </b-col>
          <b-col cols="12" md="auto">
            <h5 class="text-dark">{{ stockCode }}</h5>
          </b-col>
          <b-col cols="12" md="auto" v-if="stockBarcode != ''">
            <h5 class="text-danger">Barkod</h5>
          </b-col>
          <b-col cols="12" md="auto">
            <h5 class="text-dark">{{ stockBarcode }}</h5>
          </b-col>
        </b-row>
      </vs-card>
      <vs-tabs v-model="active_tab">
        <vs-tab label="Stok Kart Detayı" @click="marketplaceChange">
          <vs-card>
            <b-row>
              <b-col>
                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Stok Adı</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockName }}</b-col>
                </b-row>
                <vs-divider></vs-divider>
                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Stok Kodu</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockCode }}</b-col>
                </b-row>
                <vs-divider></vs-divider>

                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Barkod</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockBarcode }}</b-col>
                </b-row>
                <vs-divider></vs-divider>

                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Ürün Kategorisi</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockCategory }}</b-col>
                </b-row>
                <vs-divider></vs-divider>

                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Renk</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockColor }}</b-col>
                </b-row>
                <vs-divider></vs-divider>

                <b-row align-h="start">
                  <b-col cols="12" md="auto">
                    <h6 class="text-warning">Beden</h6>
                  </b-col>
                  <b-col cols="12" md="auto">{{ stockSize }}</b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col cols="4">
                    <h6 class="text-warning">Ürün Açıklaması</h6>
                  </b-col>
                  <b-col><vs-textarea height="150px" v-model="stockDescription" /></b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <h6 class="text-warning">Tanımlı Diğer Özellikler</h6>
                  </b-col>
                  <b-col><vs-textarea height="150px" v-model="stockDetails" /></b-col>
                </b-row>
              </b-col>
            </b-row>
          </vs-card>
        </vs-tab>
        <vs-tab label="Stok Resimleri" @click="marketplaceChange">
          <StokListesiResimTab :pictureData="data" />
        </vs-tab>
        <vs-tab
          v-for="(tabval, tabind) in tabList"
          :key="'A' + tabind"
          :label="tabval.name"
          @click="
            marketplaceChange();
            pazaryeriDetay(tabval.name);
          "
        >
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col>
                  <div v-if="marketplaceInformation != ''" class="text-danger">
                    <h4
                      :class="
                        marketplaceInformation == 'Kategori Eşlemesi Başarılı'
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      {{ marketplaceInformation }}
                    </h4>
                  </div>
                  <div
                    v-else
                    style="height: 55px"
                    id="loading-stockDetail"
                    class="vs-con-loading__container"
                  ></div>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <vs-card>
                <b-row align-v="center">
                  <b-col cols="4" style="font-size: 15px">Kategorisi</b-col>
                  <b-col cols="8">
                    <h6>{{ stockDetailCategory }}</h6>
                  </b-col>
                </b-row>
                <b-row align-v="center">
                  <b-col cols="4" style="font-size: 15px">Satış Fiyatı</b-col>
                  <b-col cols="8">
                    <vs-input v-model="stockDetailSalePrice" />
                  </b-col>
                </b-row>
                <b-row align-v="center">
                  <b-col cols="4" style="font-size: 15px">Piyasa Fiyatı</b-col>
                  <b-col cols="8">
                    <vs-input v-model="stockDetailCurrentPrice" />
                  </b-col>
                </b-row>
                <b-row align-v="center">
                  <b-col cols="4" style="font-size: 15px">Gönderilecek Adet</b-col>
                  <b-col cols="8">
                    <vs-input v-model="stockDetailCount" />
                  </b-col>
                </b-row>
                <b-row align-v="center">
                  <b-col cols="4" style="font-size: 15px">Desi</b-col>
                  <b-col cols="8">
                    <vs-input v-model="stockDetailDeci" />
                  </b-col>
                </b-row>
                <b-row align-v="center" v-if="tabval == 'N11'">
                  <b-col cols="4" style="font-size: 15px">Hazırlık Süresi</b-col>
                  <b-col cols="8">
                    <v-select
                      style="width: 200px"
                      :options="['1', '2', '3', '4', '5', '6', '7+']"
                      v-model="preparedTime"
                    ></v-select>
                  </b-col>
                </b-row>

                <div
                  slot="footer"
                   :style="{ marginTop: '40px', marginBottom:'40px'}"
                  v-if="stockDetailStatus == '2'"
                >
                  <vs-row vs-justify="flex-end">
                    <vs-button
                      @click="
                        warningText = 'Ürün pazaryerinden güncellenecek. Emin misiniz?';
                        activePromptStockUpdate = true;
                      "
                      style="border-radius: 5px"
                      type="gradient"
                      id="button-with-loading-update"
                      class="vs-con-loading__container"
                      >Güncelle</vs-button
                    >
                  </vs-row>
                </div>
                <div
                  slot="footer"
                   :style="{ marginTop: '40px', marginBottom:'40px'}"
                  v-else-if="
                    marketplaceInformation == 'Kategori Eşlemesi Başarılı' ||
                    marketplaceInformation ==
                      'Dikkat! Aşağıdaki alanlar stok kartında getirildi'
                  "
                >
                  <vs-row vs-justify="flex-end">
                    <vs-button
                      @click="gonderimListesineEkle()"
                      style="border-radius: 5px"
                      type="gradient"
                      id="button-with-loading-listeyeekle"
                      class="vs-con-loading__container"
                      >Listeye Ekle</vs-button
                    >
                    <vs-button
                      @click="sendMarketplace()"
                      style="border-radius: 5px"
                      color="danger"
                      type="gradient"
                      :disabled="validateGonder"
                      >Pazaryerine Gönder</vs-button
                    >
                    <vs-button
                      @click="propertyMatch()"
                      style="border-radius: 5px"
                      color="success"
                      type="gradient"
                      >Özellik Eşleştir</vs-button
                    >
                  </vs-row>
                </div>
                <div slot="footer" :style="{ marginTop: '40px', marginBottom:'40px'}" v-else>
                  <vs-row vs-justify="flex-end">
                    <vs-button
                      disabled
                      style="border-radius: 5px"
                      type="gradient"
                      class="vs-con-loading__container mr-2"
                      >Listeye Ekle</vs-button
                    >
                    <vs-button
                      disabled
                      style="border-radius: 5px"
                      color="danger"
                      type="gradient"
                      class="mr-2"
                      >Pazaryerine Gönder</vs-button
                    >
                    <vs-button
                      disabled
                      style="border-radius: 5px"
                      color="success"
                      type="gradient"
                      >Özellik Eşleştir</vs-button
                    >
                  </vs-row>
                </div>
              </vs-card>
            </b-col>

            <b-col
              cols="6"
              v-if="marketplaceInformation != 'Eşleşen Kategori Bulunamadı'"
            >
              <vs-card
                v-if="
                  validatedAlan1 == false ||
                  validatedAlan2 == false ||
                  validatedAlan3 == false ||
                  validatedAlan4 == false ||
                  validatedAlan5 == false ||
                  validatedAlan6 == false ||
                  validatedAlan7 == false ||
                  validatedAlan8 == false ||
                  validatedAlan9 == false ||
                  validatedAlan10 == false
                "
              >
                <b-row align-v="center" :hidden="validatedAlan1">
                  <b-col cols="3">{{ alan1Ad }}</b-col>
                  <b-col cols="9">{{ alan1Deger }} </b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan2">
                  <b-col cols="3">{{ alan2Ad }}</b-col>
                  <b-col cols="9"> {{ alan2Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan3">
                  <b-col cols="3">{{ alan3Ad }}</b-col>
                  <b-col cols="9">{{ alan3Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan4">
                  <b-col cols="3"> {{ alan4Ad }} </b-col>
                  <b-col cols="9"> {{ alan4Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan5">
                  <b-col cols="3">{{ alan5Ad }}</b-col>
                  <b-col cols="9">{{ alan5Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan6">
                  <b-col cols="3">{{ alan6Ad }}</b-col>
                  <b-col> {{ alan6Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan7">
                  <b-col cols="3"> {{ alan7Ad }} </b-col>
                  <b-col cols="9"> {{ alan7Deger }} </b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan8">
                  <b-col cols="3">{{ alan8Ad }}</b-col>
                  <b-col cols="9">{{ alan8Deger }}</b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan9">
                  <b-col cols="3">Manuel durumu:</b-col>
                  <b-col cols="9">
                    <vs-switch
                      style="border-radius: 25px"
                      v-model="alan9Ad"
                      @change="
                        warningText =
                          'Ürün otomatik güncelleme durumu güncellenecek. Emin misiniz?';
                        activePromptStockUpdate = true;
                      "
                      vs-icon="done"
                  /></b-col>
                </b-row>
                <b-row align-v="center" :hidden="validatedAlan10">
                  <b-col cols="3">{{ alan10Ad }}</b-col>
                  <b-col cols="9"> {{ alan10Deger }}</b-col>
                </b-row>
              </vs-card>
            </b-col>
          </b-row>
          <div v-if="statusMessage != ''">{{ statusMessage }}</div>
          <!--
          <b-form-input v-model="relatedProduct" @keyup.enter="anaUrunListesi()" id="smallInput"
            placeholder="İlişkili Ürün" />-->
          <ag-grid-vue
            style="width: 100%; height: 400px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowData="subProductList"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
    <vs-prompt
      color="warning"
      :title="warningText"
      acceptText="Güncelle"
      cancelText="Vazgeç"
      @cancel="updateCancel()"
      @close="updateCancel()"
      @accept="stockUpdateManuel()"
      :active.sync="activePromptStockUpdate"
    >
    </vs-prompt>
    <vs-popup title="N11 Gönderilecek Katalog Seçimi" :active.sync="popupStokAktar">
      <b-row align-h="center">
        <b-col cols="12" md="auto">
          <h5 style="color: red">Stok Kart Bilgisi</h5>
        </b-col>
        <b-col cols="12" md="auto"> </b-col>
      </b-row>
      <StokAktarComponent ref="stokAktarPopup" :StokAktarList="StokAktarList" />
    </vs-popup>
  </div>
</template>

<script>
import StokAktarComponent from "../components/uzum-components/stoklistesi-components/StokAktarComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import StokListesiResimTab from "./StokListesiResimTab.vue";
import AltUrunDurumViewCellRenderer from "./CellRenderers/AltUrunDurumViewCellRenderer.vue";
import KategoriOzellik from "./KategoriOzellik.vue";
import { fixTurkishCharsDeep } from "../../helpers/fixTurkishChars";
export default {
  components: {
    StokAktarComponent,
    AgGridVue,
    StokListesiResimTab,
    AltUrunDurumViewCellRenderer,
    KategoriOzellik,
  },
  data() {
    return {
      popupStokAktar: false,
      StokAktarList: [],

      statusMessage: "",
      popupActiveSiparis2: false,
      warningText: "",
      activePromptStockUpdate: false,
      marketplaceInformation: "",
      validateListeyeEkle: false,
      validateGonder: false,
      relatedProduct: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      localeText: null,
      subProductList: null,
      tabList: [],
      active_tab: 0,
      stockName: "",
      stockBarcode: "",
      stockCode: "",
      stockCategory: "",
      stockColor: "",
      stockSize: "",
      stockCount: "",
      stockStatus: "",
      stockDescription: "",
      stockDetails: "",
      stockAlan1: "",
      stockAlan2: "",
      stockAlan3: "",
      stockAlan4: "",
      stockAlan5: "",
      stockAlan6: "",
      stockAlan7: "",
      stockAlan8: "",
      stockAlan9: "",
      stockAlan10: "",
      stockSalePrice: "",
      stockCurrentPrice: "",
      stockKdv: "",
      stockMateCode: "",
      stockSupplier: "",
      stockBrand: "",
      N11KatalogId: "",
      GGKatalogId: "",
      HBKatalogId: "",

      stockDetailCategory: "",
      stockDetailCategoryId: "",
      stockDetailSalePrice: "",
      stockDetailCurrentPrice: "",
      stockDetailCount: "",
      stockDetailAlan1: "",
      stockDetailAlan2: "",
      stockDetailAlan3: "",
      stockDetailAlan4: "",
      stockDetailAlan5: "",
      stockDetailAlan6: "",
      stockDetailAlan7: "",
      stockDetailAlan8: "",
      stockDetailAlan9: "",
      stockDetailAlan10: "",
      stockDetailSubStatus: "",
      stockDetailStatus: "",
      stockDetailDeci: "",
      stockDetailGainRate: "",
      stockDetailCargoSum: "",
      preparedTime: "",

      validatedAlan1: true,
      validatedAlan2: true,
      validatedAlan3: true,
      validatedAlan4: true,
      validatedAlan5: true,
      validatedAlan6: true,
      validatedAlan7: true,
      validatedAlan8: true,
      validatedAlan9: true,
      validatedAlan10: true,
      alan1Ad: "",
      alan2Ad: "",
      alan3Ad: "",
      alan4Ad: "",
      alan5Ad: "",
      alan6Ad: "",
      alan7Ad: "",
      alan8Ad: "",
      alan9Ad: "",
      alan10Ad: "",
      alan1Deger: "",
      alan2Deger: "",
      alan3Deger: "",
      alan4Deger: "",
      alan5Deger: "",
      alan6Deger: "",
      alan7Deger: "",
      alan8Deger: "",
      alan9Deger: "",
      alan10Deger: "",

      activeMarketplace: "",
    };
  },
  props: {
    isPromptActiveStockDetail: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => ({}),
      required: true,
    },
  },
  mounted() {
    this.$root.$on("closeCategoryProperties", () => {
      this.closeCategoryProperties();
    });
    this.$root.$on("removeSubList", (data) => {
      this.removeSubList(data);
    });
    this.$root.$on("addSubStockList", (data) => {
      this.addSubStockList(data);
    });
    this.$root.$on("stokaktarpopup", () => {
      this.stokaktarpopup();
    });
  },
  beforeDestroy() {
    this.$root.$off("removeSubList");
    this.$root.$off("addSubStockList");
    this.$root.$off("closeCategoryProperties");
    this.$root.$off("stokaktarpopup");
  },
  watch: {
    isPromptActiveStockDetail(val) {
      // Popup kapanirken de tetiklendigi icin alanlar eski veriyle tekrar doluyordu
      if (!val) return;
      this.setTabList();
      this.fillStockCard();
    },
    data() {
      // Popup acikken satir degisirse kart bilgisi de guncellensin
      if (this.isPromptActiveStockDetail) this.fillStockCard();
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isPromptActiveStockDetail;
      },
      set(val) {
        if (!val) {
          this.$emit("closeStockPopup");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  methods: {
    stokaktarpopup() {
      this.popupStokAktar = false;
    },
    setTabList() {
      let moduller = [];
      try {
        moduller = JSON.parse(Store.state.moduller) || [];
      } catch (error) {
        moduller = [];
      }
      this.tabList = moduller.map((modul) => ({ name: modul.marketplace }));
    },
    // stokListesi satirini popup ustundeki kart alanlarina yazar
    fillStockCard() {
      const kayit = this.data;
      if (!kayit) return;

      // SATIS_FIAT1 / StokAdet / kdv sayi olarak geliyor, string'e cevirir
      const metin = (deger) =>
        deger === null || typeof deger === "undefined" ? "" : String(deger);

      this.stockName = metin(kayit.StokAdi);
      this.stockBarcode = metin(kayit.Barkod);
      this.stockCode = metin(kayit.stokKodu);
      this.stockCategory = metin(kayit.kategori1);
      this.stockColor = metin(kayit.renk);
      this.stockSize = metin(kayit.beden);
      this.stockDescription = metin(kayit.detay);
      this.stockAlan1 = metin(kayit.alan1);
      this.stockAlan2 = metin(kayit.alan2);
      this.stockAlan3 = metin(kayit.alan3);
      this.stockAlan4 = metin(kayit.alan4);
      this.stockAlan5 = metin(kayit.alan5);
      this.stockAlan6 = metin(kayit.alan6);
      this.stockAlan7 = metin(kayit.alan7);
      this.stockAlan8 = metin(kayit.alan8);
      this.stockAlan9 = metin(kayit.alan9);
      this.stockAlan10 = metin(kayit.alan10);
      this.stockStatus = metin(kayit.eklenmeDurumu);
      this.stockSalePrice = metin(kayit.SATIS_FIAT1);
      this.stockCount = metin(kayit.StokAdet);
      this.stockKdv = metin(kayit.kdv);
      this.stockMateCode = metin(kayit.ortakKod);
      this.stockBrand = metin(kayit.marka);

      // Dolu olan alan1..alan10 degerlerini "ad = deger" seklinde alt alta yazar
      this.stockDetails = [
        this.stockAlan1,
        this.stockAlan2,
        this.stockAlan3,
        this.stockAlan4,
        this.stockAlan5,
        this.stockAlan6,
        this.stockAlan7,
        this.stockAlan8,
        this.stockAlan9,
        this.stockAlan10,
      ]
        .filter((deger) => deger !== "")
        .map((deger) => deger.replace("*", " = "))
        .join("\n");
    },
    sendMarketplace() {
      var vm = this;
      var vs = this.$vs;
      if (vm.activeMarketplace == "N11") {
        vm.popupGonderilenStokListesi = true;
      } // bakılacak
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: vm.activeMarketplace,
        token: Store.state.tokenId,
        barkod: vm.stockBarcode,
        tedarikci: typeof vm.stockSupplier == "undefined" ? "" : vm.stockSupplier,
        marka: typeof vm.stockBrand == "undefined" ? "" : vm.stockBrand,
        teslimatSablonu: "",
        hazirlikSuresi: vm.preparedTime,
      };
      console.log(args);
      if (vm.preparedTime == "" && vm.activeMarketplace == "N11") {
        vs.notify({
          title: "Hazırlık Süresi",
          text: "Lütfen Hazırlık Süresi Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "dark",
          position: "top-center",
        });
      } else {
        soap.createClient(url, function (err, client) {
          client.StokAktar(args, function (err, result) {
            if (result.StokAktarResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              var sonuc = result.StokAktarResult;
              //  const userStr = JSON.stringify(sonuc);
              vm.veriler = JSON.parse(sonuc);
              if (vm.veriler.response == "Ok") {
                vm.gonderilenStokListesi = vm.veriler;
                vm.popupGonderilenStokListesi = true;

                if (vm.activeMarketplace == "N11") {
                  vm.StokAktarList = vm.veriler.json;
                  console.log(vm.StokAktarList);

                  if (typeof vm.StokAktarList != "undefined") {
                    vm.popupStokAktar = true;
                    vm.$store.commit("uzum/STOK_AKTAR_LIST", vm.StokAktarList);
                    vm.$refs.stokAktarPopup.listele(vm.stockBarcode);
                  } else {
                    vs.notify({
                      title: "Pazaryerine",
                      text: "Pazaryerine Gönderim Başarılı",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "success",
                      position: "top-center",
                    });
                  }
                } else {
                  vs.notify({
                    title: "Pazaryerine",
                    text: "Pazaryerine Gönderim Başarılı",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                }
              } else {
                vs.notify({
                  title: "Pazaryerine Gönderim Hatası",
                  text: vm.veriler.mesaj,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
              if (vm.activeMarketplace == "Trendyol")
                vm.statusMessage = d.errors[0].message;
              else if (vm.activeMarketplace == "Hepsiburada") {
                let mesajHB = vm.veriler.json[0].importMessages.split("&");
                vm.statusMessage = mesajHB[1] + "eksikler";
              }
            } catch (error) {
              console.log(error);
              console.log(result);
              vs.notify({
                title: "Pazaryerine Gönderim Hatası",
                text: error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    closeCategoryProperties() {
      this.popupActiveSiparis2 = false;
    },
    updateCancel() {
      this.alan9Ad = !this.alan9Ad;
    },

    stockUpdateManuel() {
      const vm = this;
      var vs = this.$vs;
      let type = "radius";

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: vm.activeMarketplace,
        barcode: vm.stockBarcode,
        price: vm.stockDetailSalePrice,
        currentprice: vm.stockDetailCurrentPrice,
        quantity: vm.stockDetailCount,
        stokKodu: vm.stockCode,
        manuelMi: vm.alan9Ad == false ? 0 : 1,
      };
      soap.createClient(url, function (err, client) {
        vs.loading({
          container: `#button-with-loading-update`,
          type,
        });
        client.AdetFiyatGuncelleManuel(args, function (err, result) {
          if (result.AdetFiyatGuncelleManuelResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.AdetFiyatGuncelleManuelResult));
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-update > .con-vs-loading");

              vs.notify({
                title: "Stok detayı",
                text: vm.veriler.mesaj,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              vm.pazaryeriDetay(vm.activeMarketplace, "upt");
              //   vm.$root.$emit("getStockList");
            } else {
              vs.loading.close("#button-with-loading-update > .con-vs-loading");

              vs.notify({
                title: "Stok detayı",
                text: vm.veriler.mesaj,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-update > .con-vs-loading");

            vs.notify({
              title: "Stok detayı",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    marketplaceChange() {
      this.stockDetailCategory = "";
      this.stockDetailCategoryId = "";
      this.stockDetailSalePrice = "";
      this.stockDetailCurrentPrice = "";
      this.stockDetailCount = "";
      this.stockDetailAlan1 = "";
      this.stockDetailAlan2 = "";
      this.stockDetailAlan3 = "";
      this.stockDetailAlan4 = "";
      this.stockDetailAlan5 = "";
      this.stockDetailAlan6 = "";
      this.stockDetailAlan7 = "";
      this.stockDetailAlan8 = "";
      this.stockDetailAlan9 = "";
      this.stockDetailAlan10 = "";
      this.stockDetailSubStatus = "";
      this.stockDetailStatus = "";
      this.stockDetailDeci = "";
      this.stockDetailGainRate = "";
      this.stockDetailCargoSum = "";
      this.statusMessage = "";

      this.validatedAlan1 = true;
      this.validatedAlan2 = true;
      this.validatedAlan3 = true;
      this.validatedAlan4 = true;
      this.validatedAlan5 = true;
      this.validatedAlan6 = true;
      this.validatedAlan7 = true;
      this.validatedAlan8 = true;
      this.validatedAlan9 = true;
      this.validatedAlan10 = true;
      this.alan1Ad = "";
      this.alan2Ad = "";
      this.alan3Ad = "";
      this.alan4Ad = "";
      this.alan5Ad = "";
      this.alan6Ad = "";
      this.alan7Ad = "";
      this.alan8Ad = "";
      this.alan9Ad = true;
      this.alan10Ad = "";
      this.alan1Deger = "";
      this.alan2Deger = "";
      this.alan3Deger = "";
      this.alan4Deger = "";
      this.alan5Deger = "";
      this.alan6Deger = "";
      this.alan7Deger = "";
      this.alan8Deger = "";
      this.alan9Deger = "";
      this.alan10Deger = "";
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      // params.api.sizeColumnsToFit();
    },
    clearFields() {
      this.activeMarketplace = "";
      this.subProductList = null;
      this.active_tab = 0;
      this.stockName = "";
      this.stockBarcode = "";
      this.stockCode = "";
      this.stockCategory = "";
      this.stockColor = "";
      this.stockSize = "";
      this.stockCount = "";
      this.stockDescription = "";
      this.stockDetails = "";
      this.stockAlan1 = "";
      this.stockAlan2 = "";
      this.stockAlan3 = "";
      this.stockAlan4 = "";
      this.stockAlan5 = "";
      this.stockAlan6 = "";
      this.stockAlan7 = "";
      this.stockAlan8 = "";
      this.stockAlan9 = "";
      this.stockAlan10 = "";
      this.statusMessage = "";

      this.$emit("closeStockPopup");
    },
    pazaryeriDetay(pazaryeri, upt) {
      this.activeMarketplace = pazaryeri;
      var vm = this;
      vm.validateGonder = true;

      var vs = this.$vs;
      vs.loading.close("#loading-stockDetail > .con-vs-loading");

      let type = "radius";
      vm.marketplaceInformation = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: pazaryeri,
        barkod: vm.stockBarcode,
        kod: vm.stockCode,
      };
      soap.createClient(url, function (err, client) {
        if (upt != "upt")
          vs.loading({
            container: `#loading-stockDetail`,
            type,
          });

        client.stokPazaryeriDetay(args, function (err, result) {
          if (result.stokPazaryeriDetayResult == "-1") {
            Store.dispatch("logout");
          }

          let stokAltKod = "";
          try {
            const parsedResponse = fixTurkishCharsDeep(JSON.parse(result.stokPazaryeriDetayResult));
            const response = Array.isArray(parsedResponse)
              ? parsedResponse[0] || {}
              : parsedResponse || {};
            // Servis "data" altinda tek nesne donebiliyor, eski formatta alanlar kokte
            const detay = response.data || response;
            vm.veriler = response;

            // null/undefined gelen alanlari string'e cevirir
            const metin = (deger) =>
              deger === null || typeof deger === "undefined" ? "" : String(deger);
            // ondalik ayraci normalize eder
            const fiyat = (deger) =>
              deger === null || typeof deger === "undefined"
                ? ""
                : String(deger).replace(",", ".");

            if (response.error == "No") {
              vs.loading.close("#loading-stockDetail > .con-vs-loading");
              console.log(detay);
              vm.stockDetailCategory = metin(detay.pazaryeriKategori);
              vm.stockDetailCategoryId = metin(detay.pazaryeriId);
              vm.stockDetailSalePrice = fiyat(detay.guncelStokFiyat);
              vm.stockDetailCurrentPrice = fiyat(detay.guncelPiyasaFiyat);
              vm.stockDetailCount = metin(detay.gonderilecekAdet);
              vm.stockDetailAlan1 = metin(detay.alan1);
              vm.stockDetailAlan2 = metin(detay.alan2);
              vm.stockDetailAlan3 = metin(detay.alan3);
              vm.stockDetailAlan4 = metin(detay.alan4);
              vm.stockDetailAlan5 = metin(detay.alan5);
              vm.stockDetailAlan6 = metin(detay.alan6);
              vm.stockDetailAlan7 = metin(detay.alan7);
              vm.stockDetailAlan8 = metin(detay.alan8);
              vm.stockDetailAlan9 = metin(detay.alan9);
              vm.stockDetailAlan10 = metin(detay.alan10);
              vm.stockDetailSubStatus = metin(detay.durumAltUrun).trim();
              // Servis durumu sayi ya da bosluklu string dondurebiliyor
              vm.stockDetailStatus = metin(detay.durum).trim();
              vm.stockDetailGainRate = fiyat(detay.karOran);
              vm.stockDetailCargoSum = fiyat(detay.kargoTutar);
              switch (pazaryeri) {
                case "Ticimax":
                  const ortakAlanTicimax = vm.stockAlan10.split("*");
                  if (ortakAlanTicimax[0] == "ortakKod") {
                    stokAltKod = ortakAlanTicimax[1];
                  } else {
                    stokAltKod = vm.stockCode;
                  }
                  break;
                case "Trendyol":
                  var ortakAlanTrendyol = "";
                  if (
                    vm.stockAlan10 == null ||
                    typeof vm.stockAlan10 == "undefined" ||
                    vm.stockAlan10 == ""
                  ) {
                  } else ortakAlanTrendyol = vm.stockAlan10.split("*");
                  if (ortakAlanTrendyol[0] == "ortakKod") {
                    stokAltKod = ortakAlanTrendyol[1];
                  } else {
                    stokAltKod = vm.stockCode;
                  }
                  break;
                case "Ikas":
                  stokAltKod = vm.stockCode;
                  break;
                case "Ozon":
                  stokAltKod = vm.stockCode;
                  break;
                case "Tsoft":
                  stokAltKod = vm.stockMateCode;
                  break;
                case "Shopify":
                //    vm.altUrunListesi(pazaryeri,vm.ortakKod); break;
                case "N11":
                  const ortakAlanN11 = vm.stockAlan10;
                  if (ortakAlanN11[0] == "ortakKod") {
                    stokAltKod = ortakAlanN11[1];
                  } else {
                    stokAltKod = vm.stockCode;
                  }
                  const argsSablon = {};
                  soap.createClient(url, function (err, clientSablon) {
                    clientSablon.teslimatSablonuCek(
                      argsSablon,
                      function (err, resultSablon) {
                        vm.verilers = JSON.parse(resultSablon.teslimatSablonuCekResult);

                        vm.optionsN11TeslimatSablonu = vm.verilers.json;
                      }
                    );
                  });
                  break;
                case "Woocommerce":
                  stokAltKod = vm.stockBarcode;

                  break;
                case "Hepsiburada":
                  stokAltKod = vm.stockCode;
                  break;
                case "Modanisa":
                  stokAltKod = vm.stockBarcode;
                  break;
              }

              switch (vm.stockDetailStatus) {
                case "0":
                  vm.validateListeyeEkle = false;
                  vm.validateGonder = true;
                  break;
                case "1":
                  vm.validateListeyeEkle = true;
                  vm.validateGonder = false;
                  break;
                case "2":
                  vm.validateListeyeEkle = true;
                  vm.validateGonder = true;
                  break;
                default:
                  vm.validateListeyeEkle = true;
                  break;
              }
              vm.marketplaceInformation = "Kategori Eşlemesi Başarılı";
              if (vm.stockDetailSalePrice == "0") {
                vm.stockDetailSalePrice = vm.stockSalePrice;
                vm.marketplaceInformation =
                  "Dikkat! Aşağıdaki alanlar stok kartında getirildi";
              }
              if (vm.stockDetailCategoryId == "") {
                vm.marketplaceInformation = "Dikkat! Eşleşen Kategori Yok";
                vm.validateListeyeEkle = true;
                vm.validateGonder = true;
              }
              if (vm.stockDetailCurrentPrice == "0") {
                vm.stockDetailCurrentPrice = vm.stockCurrentPrice;
              }
              if (vm.stockDetailCount == "0") {
                vm.stockDetailCount = vm.stockCount;
              }
              if (vm.stockDetailAlan1 != "") {
                vm.validatedAlan1 = false;
                const ayir = vm.stockDetailAlan1.split("*");
                vm.alan1Ad = ayir[0];
                vm.alan1Deger = ayir[1];
              }

              if (vm.stockDetailAlan2 != "") {
                vm.validatedAlan2 = false;
                const ayir = vm.stockDetailAlan2.split("*");
                vm.alan2Ad = ayir[0];
                vm.alan2Deger = ayir[1];
              }

              if (vm.stockDetailAlan3 != "") {
                vm.validatedAlan3 = false;
                const ayir = vm.stockDetailAlan3.split("*");
                vm.alan3Ad = ayir[0];
                vm.alan3Deger = ayir[1];
              }

              if (vm.stockDetailAlan4 != "") {
                vm.validatedAlan4 = false;
                const ayir = vm.stockDetailAlan4.split("*");
                vm.alan4Ad = ayir[0];
                vm.alan4Deger = ayir[1];
              }

              if (vm.stockDetailAlan5 != "") {
                vm.validatedAlan5 = false;
                const ayir = vm.stockDetailAlan5.split("*");
                vm.alan5Ad = ayir[0];
                vm.alan5Deger = ayir[1];
              }

              if (vm.stockDetailAlan6 != "") {
                vm.validatedAlan6 = false;
                const ayir = vm.stockDetailAlan6.split("*");
                vm.alan6Ad = ayir[0];
                vm.alan6Deger = ayir[1];
              }

              if (vm.stockDetailAlan7 != "") {
                vm.validatedAlan7 = false;
                const ayir = vm.stockDetailAlan7.split("*");
                vm.alan7Ad = ayir[0];
                vm.alan7Deger = ayir[1];
              }

              if (vm.stockDetailAlan8 != "") {
                vm.validatedAlan8 = false;
                const ayir = vm.stockDetailAlan8.split("*");
                vm.alan8Ad = ayir[0];
                vm.alan8Deger = ayir[1];
              }

              if (vm.stockDetailAlan9 != "") {
                vm.validatedAlan9 = false;
                const ayir = vm.stockDetailAlan9.split("*");
                vm.alan9Ad = ayir[0];
                vm.alan9Deger = ayir[1];
                vm.alan9Ad = vm.alan9Ad == 1 ? true : false;
              }

              if (vm.stockDetailAlan10 != "") {
                vm.validatedAlan10 = false;
                const ayir = vm.stockDetailAlan10.split("*");
                vm.alan10Ad = ayir[0];
                vm.alan10Deger = ayir[1];
              }

              switch (pazaryeri) {
                case "Trendyol":
                  break;

                case "N11":
                  vm.dParaBirim = detay.dParaBirim;
                  break;

                case "Hepsiburada":
                  break;

                case "Ticimax":
                  break;

                case "Tsoft":
                  break;

                case "Gittigidiyor":
                  vm.dDurum = vm.stockDetailStatus;
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Ciceksepeti":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Ikas":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Ozon":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;
                case "Modanisa":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Opencart":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;
                case "Allesgo":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "AkinSoft":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "PlatinMarket":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Woocommerce":
                  vm.stockMateCode = metin(detay.ortakKod);
                  break;

                case "PttAvm":
                  vm.alan10 = vm.stockDetailAlan10;
                  vm.stockMateCode = metin(detay.ortakKod);
                  break;

                case "Azall":
                  vm.alan10 = vm.stockDetailAlan10;
                  vm.stockMateCode = metin(detay.ortakKod);
                  break;

                case "Shopify":
                  vm.alan10 = vm.stockDetailAlan10;
                  break;

                case "Pazarama":
                  vm.dParaBirim = detay.dParaBirim;
                  break;

                case "Ideasoft":
                  vm.dParaBirim = detay.dParaBirim;
                  break;

                case "Etsy":
                  vm.dParaBirim = detay.dParaBirim;

                  break;

                case "PhpWebServis":
                  vm.dParaBirim = detay.dParaBirim;
                  break;
              }

              vm.altUrunListesi(pazaryeri, stokAltKod);
              if (vm.stockStatus == "anaUrun") {
                vm.anaUrunListesi();
              }
            } else {
              vs.loading.close("#loading-stockDetail > .con-vs-loading");
              vm.marketplaceInformation =
                response.message || detay.message || "Stok pazaryeri detayı alınamadı";
              vs.notify({
                title: "Stok detayı",
                text: vm.marketplaceInformation,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close("#loading-stockDetail > .con-vs-loading");
            vs.notify({
              title: "Stok detayı",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    gonderimListesineEkle() {
      var vs = this.$vs;
      var vm = this;

      let args = {
        token: Store.state.tokenId,
        program: vm.activeMarketplace,
        stokKodu: vm.stockCode,
        stokAdi: vm.stockName,
        durum: 1,
        barkod: vm.stockBarcode,
        gonderilecekAdet: vm.stockDetailCount,
        alan1: vm.stockDetailAlan1,
        alan2: vm.stockDetailAlan2,
        alan3: vm.stockDetailAlan3,
        alan4: vm.stockDetailAlan4,
        alan5: vm.stockDetailAlan5,
        alan6: vm.stockDetailAlan6,
        alan7: vm.stockDetailAlan7,
        alan8: vm.stockDetailAlan8,
        alan9: vm.stockDetailAlan9,
        alan10: vm.stockDetailAlan10,
        renk: vm.stockColor,
        beden: vm.stockSize,
        fiyat: vm.stockDetailSalePrice,
        adet: vm.stockDetailCount,
        gonderilecekFiyat: vm.stockDetailSalePrice,
        gonderilecekPiyasaFiyati: vm.stockDetailCurrentPrice,
        pazaryeriId: vm.stockDetailCategoryId,
        detay: vm.stockDescription,
        kdv: vm.stockKdv,
        anaStokKodu: "",
        ortakKod: vm.stockMateCode,
        pazaryeriCode: vm.stockDetailCategoryId,
        desi: vm.stockDetailDeci == "" ? 0 : vm.stockDetailDeci,
        N11KatalogId: vm.N11KatalogId,
        HBKatalogId: typeof vm.HBKatalogId == "undefined" ? "" : vm.HBKatalogId,
        GGKatalogId: vm.GGKatalogId,
      };

      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-listeyeekle",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(args);

      soap.createClient(url, function (err, client) {
        client.gonderimListesineEkle(args, function (err, result) {
          if (result.gonderimListesineEkleResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            console.log(result);
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.gonderimListesineEkleResult));
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
              vs.notify({
                title: "Gönderim Listesi",
                text: "Ekleme İşlemi Başarılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              vm.pazaryeriDetay(vm.activeMarketplace);
            } else {
              vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
              vs.notify({
                title: "Gönderim Listesi",
                text: "Eklemede Hata Oluştu" + vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
            //vm.altUrunListesi(pazaryeri, this.dBarkod); //Burayı Kontrol Et
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-listeyeekle > .con-vs-loading");
            vs.notify({
              title: "Gönderim Listesi",
              text: "Eklemede Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },

    propertyMatch() {
      this.popupActiveSiparis2 = true;
    },

    anaUrunListesi() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: vm.activeMarketplace,
        kod: vm.relatedProduct == "" ? "-" : vm.relatedProduct,
      };
      //yarım bırakıldı, tamamlanacak
      soap.createClient(url, function (err, client) {
        client.anaUrunListesi(args, function (err, result) {
          vm.verilers = fixTurkishCharsDeep(JSON.parse(result.anaUrunListesiResult));
        });
      });
    },
    altUrunListesi(program, stokKodu) {
      // alert(stokKodu)
      var vs = this.$vs;

      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        stokKodu: stokKodu,
        token: Store.state.tokenId,
        ekAlan: vm.stockAlan9,
        pazaryeri: program,
      };

      soap.createClient(url, function (err, client) {
        client.altUrunListesiProgram(args, function (err, result) {
          if (result.altUrunListesiProgramResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.altUrunListesiProgramResult));
            vm.subProductList = vm.veriler;
            vm.columnDefs = [];
            let list = vm.veriler;
            let columnList = Object.keys(list[0]);
            columnList.forEach((val, index) => {
              if (val == "eslesmeDurumu") {
                vm.columnDefs.push({
                  width: 100,
                  pinned: "left",
                  filter: "agSetColumnFilter",
                  field: val,
                  wrapText: true,
                  autoHeight: true,
                  cellRenderer: "AltUrunDurumViewCellRenderer",
                });
              } else
                vm.columnDefs.push({
                  field: val,
                  filter: "agSetColumnFilter",
                });
            });
          } catch (error) {
            vm.subProductList = [];
          }
        });
        //Vue.prototype.$vs = this.$vs;
      });
    },
    removeSubList(data) {
      //  document.getElementById("cikar" + stokKodu).disabled = true;

      var vm = this;
      var vs = this.$vs;
      let args = {
        token: Store.state.tokenId,
        pazaryeri: vm.activeMarketplace,
        stokKodu: data,
      };
      const url = state.sistemAddress;
      const soap = require("soap");
      soap.createClient(url, function (err, client) {
        client.altGonderimListesiKaldir(args, function (err, result) {
          if (result.altGonderimListesiKaldirResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vs.notify({
              title: "Alt ürün listesi",
              text: "Alt ürün silindi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.altUrunListesi(pazaryeri, vm.ortakKod);
          } catch (error) {
            vs.notify({
              title: "Alt ürün listesi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    addSubStockList(data) {
      //   document.getElementById("ekle" + data.stokKodu).disabled = true;
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(data);
      let args = {
        token: Store.state.tokenId,
        program: vm.activeMarketplace,
        stokKodu: data.stokKodu,
        stokAdi: data.StokAdi,
        durum: 1,
        barkod: data.Barkod,
        gonderilecekAdet: data.stokAdet,
        alan1: "",
        alan2: "",
        alan3: "",
        alan4: "",
        alan5: "",
        alan6: "",
        alan7: "",
        alan8: "",
        alan9: "",
        alan10: "",
        renk: data.renk,
        beden: data.beden,
        fiyat: data.SATIS_FIAT1,
        adet: data.stokAdet,
        gonderilecekFiyat: data.SATIS_FIAT1,
        gonderilecekPiyasaFiyati: data.SATIS_FIAT1,
        pazaryeriId: vm.stockDetailCategoryId,
        detay: vm.stockDescription,
        kdv: data.kdv,
        anaStokKodu: data.anaStokKodu,
        ortakKod: data.ortakKod,
        pazaryeriCode: vm.stockDetailCategoryId,
        AzallKatalogId: vm.AzallKatalogId,
        N11KatalogId: vm.N11KatalogId,
        HBKatalogId: typeof vm.HBKatalogId == "undefined" ? "" : vm.HBKatalogId,
        GGKatalogId: vm.GGKatalogId,
      };
      soap.createClient(url, function (err, client) {
        client.gonderimListesineEkle(args, function (err, result) {
          if (result.gonderimListesineEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.gonderimListesineEkleResult));
          //console.log("gonderimListesineEkleResult" + vm.veriler);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Gönderim Listesi",
              text: "Ekleme İşlemi Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Gönderim Listesi",
              text: "Eklemede Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center",
            });
          }
          // vm.veriler=fixTurkishCharsDeep(JSON.parse(result.gonderimListesineEkleResult))

          //console.log("Alt gonderimListesineEkle: "+vm.veriler)
          // vm.resimYukle(result.gonderimListesineEkleResult,0,1,pazaryeri)
          //vm.altUrunListesi(pazaryeri, vm.ortakKod);
        });
      });
    },
  },
};
</script>

<style>
textarea {
  height: 100%;
}

.vuesax-app-is-ltr .con-vs-dialog {
  z-index: 111111 !important;
}

.vuesax-app-is-ltr .con-vs-dialog {
  z-index: 1111111 !important;
}

.vs-notifications {
  z-index: 2000100 !important;
}
</style>
